import React from 'react'

const ColorSelector = ({ label, onChangeHandler }) => {

  return (
    <div className="calculator--form-group">
      <label className="calculator--input-label" style={{ width: '100%' }}>{label}</label>
    <div className="color-picker-container">
      <label className="color-picker">
        <input type="radio" name="level" value="1" onChange={() => onChangeHandler(450)}/>
        <span className="checkmark" id="level1"></span>
      </label>
      <label className="color-picker" >
        <input type="radio" name="level" value="2" onChange={() => onChangeHandler(550)}/>
        <span className="checkmark" id="level2"></span>
      </label>
      <label className="color-picker" >
        <input type="radio" name="level" value="3" onChange={() => onChangeHandler(650)}/>
        <span className="checkmark" id="level3"></span>
      </label>
      <label className="color-picker" >
        <input type="radio" name="level" value="4" onChange={() => onChangeHandler(750)}/>
        <span className="checkmark" id="level4"></span>
      </label>
      <label className="color-picker" >
        <input type="radio" name="level" value="5" onChange={() => onChangeHandler(900)}/>
        <span className="checkmark" id="level5"></span>
      </label>
      <label className="color-picker" >
        <input type="radio" name="level" value="6" onChange={() => onChangeHandler(1100)}/>
        <span className="checkmark" id="level6"></span>
      </label>
      <label className="color-picker" >
        <input type="radio" name="level" value="7" onChange={() => onChangeHandler(1300)}/>
        <span className="checkmark" id="level7"></span>
      </label>
    </div>
    </div>
  );
};

export default ColorSelector;